import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState as unassignedPickup, UnassignedPickupState } from "./UnassignedPickupState";
import { IState } from "slices";


export const unassignedPickupSlice = createSlice({
  name: "unassignedPickup",
  initialState: unassignedPickup,
  reducers: {
    setStaticRoutes: (state, action: PayloadAction<{ data: UnassignedPickupState }>) => {
      const { data } = action.payload;
      state.staticRouteGroups = data.staticRouteGroups;
      state.pickupsWithoutStaticRoute = data.pickupsWithoutStaticRoute;
      if (data.unassignedTabCounts != null) {
        state.unassignedTabCounts = data.unassignedTabCounts;
      }
      if (data.loadedForTerminalId !== undefined) {
        state.loadedForTerminalId = data.loadedForTerminalId;
      }
    },
  },
});

export const { setStaticRoutes } = unassignedPickupSlice.actions;

export const unassignedPickupSelector = (state: IState) => state.unassignedPickup;

const unassignedPickupReducer = unassignedPickupSlice.reducer;
export default unassignedPickupReducer;
